import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  // InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
} from "@mui/material";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Aside from "../../component/aside/Aside";
import Footer2 from "../../component/footer/Footer2";
import Header from "../../component/header/Header";
// import PumaLogo from "../../assets/images/offer-logo3.png";
// import DecathlonLogo from "../../assets/images/offer-logo2.png";
// import ZomatoLogo from "../../assets/images/zomato.png";
import gold_rupe_icon_md from "../../assets/images/gold_rupe_md.svg";
// import BHLogo from "../../assets/images/offer-logo4.png";
// import SwiggyLogo from "../../assets/images/swiggy.png";
// import NikeLogo from "../../assets/images/offer-logo1.png";
// import BackIcon from "../../assets/images/LineWhiteArrow.svg";
import { fetchRewards } from "../../redux/slice/offers/rewards";
import { fetchRedemptionAllowance } from "../../redux/slice/offers/redemptionAllowance";
import { formatRewardCatalogueAmount } from "../../utils/common";
import {
  REDEMPTION_ALLOWANCE_COPY,
  getBlockedReason,
  isRewardBlocked,
} from "../../utils/redemptionAllowance";
import "./OffersHistory.scss";
import moment from "moment";
import Spinner from "../../component/spinner/Spinner";
import ActiveOffers from "./ActiveOffers";
import ExpiredRewards from "./ExpiredRewards";
import { fetchCategoryList } from "../../redux/slice/category-list/categoryList";
import NoDataComp from "../../component/NoDataComp";
import { fetchCustomerDetails } from "../../redux/slice/customerDetails";

const OffersHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { rewardsData, loading } = useSelector((state) => state.rewards);
  const { categoryListData } = useSelector((state) => state.categoryList);
  const redemptionAllowance = useSelector((state) => state.redemptionAllowance);

  // const [rewardsDataTierWise, setRewardsDataTierWise] = useState([]);

  const [rewards, setRewards] = useState([]);
  const [mall, setMall] = useState("");
  const [activeTab, setActiveTab] = useState("v-pills-home");
  const [currenttabIndex, setCurrenttabIndex] = useState(0);
  const handleChange = (event, newValue) => {
    setCurrenttabIndex(newValue);
  };

  const mobile = localStorage.getItem("mobile");
  const { customerDetailsData } = useSelector((state) => state.customerDetails);
  const currentSlab = customerDetailsData?.current_slab;
  useEffect(() => {
    if (mobile) {
      dispatch(fetchCustomerDetails());
    }
    // eslint-disable-next-line
  }, [mobile]);
  useEffect(() => {
    if (sessionStorage.getItem("rediFromReward")) {
      sessionStorage.removeItem("rediFromReward");
      setCurrenttabIndex(1);
    }
    // eslint-disable-next-line
  }, []);

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      Rewards Catalogue
    </Typography>,
  ];
  const breadcrumbsMobile = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      Rewards Catalogue
    </Typography>,
  ];
  const handleSubmit = (key, tab) => {
    if (tab === 0) {
      const today = new Date();
      const filteredArray = rewardsData?.filter((item) => {
        const startTime = new Date(item?.startTime);
        const rewardLevel = item?.rewardRestrictions?.rewardLevel?.[0];
        if (!rewardLevel) return true;
        return startTime <= today && rewardLevel?.consumed < rewardLevel?.limit;
      });
      const filterRew = filterRewardsData(filteredArray, currentSlab);

      if (key === "All" || key === "") {
        setRewards(filterRew);
      } else if (key === "special benefits") {
        const result = filterRew?.filter((el) => el?.intouchPoints === 0);
        setRewards(result);
      } else {
        const result = filterRew?.filter(
          (el) => el.categoryList[0]?.name === key,
        );
        // console.log(result, "result");
        setRewards(result);
      }
    }

    return;
  };
  function filterRewardsData(data, userTier) {
    // Define the tier hierarchy
    const tierHierarchy = ["Silver", "Gold", "Platinum", "Exclusive"];

    return data.filter((item) => {
      const { tier } = item;
      if (!tier) return true;

      // Split the tier string into individual tiers
      const tiers = tier.split("|");

      // Get the indices of the tiers in the hierarchy
      const indices = tiers.map((t) => tierHierarchy.indexOf(t));
      const minTierIndex = Math.min(...indices);
      const maxTierIndex = Math.max(...indices);

      // Get the index of the user's tier in the hierarchy
      const userTierIndex = tierHierarchy.indexOf(userTier);

      // Apply the filtering rules
      if (tiers.length === 1) {
        // Single-tier rules
        return userTierIndex === minTierIndex;
      } else {
        // multi-tier rules
        return userTierIndex <= maxTierIndex;
      }
    });
  }
  useEffect(() => {
    dispatch(fetchRewards());
    dispatch(fetchCategoryList());
    dispatch(fetchRedemptionAllowance());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (currentSlab) {
      const filterRew = filterRewardsData(rewardsData, currentSlab);
      const today = new Date();
      const filteredArray = filterRew?.filter((item) => {
        const startTime = new Date(item?.startTime);
        const rewardLevel = item?.rewardRestrictions?.rewardLevel?.[0];
        if (!rewardLevel) return true;
        return startTime <= today && rewardLevel?.consumed < rewardLevel?.limit;
      });
      setRewards(filteredArray);
    }
    // setRewards(rewardsData);
    // eslint-disable-next-line
  }, [rewardsData]);

  const capitalizeCategory = (str) => {
    return str
      .split(" ")
      .map((word, index) => {
        // Keep common small words lowercase unless they are the first word
        const exceptions = ["of", "and", "the", "in", "on", "at", "to"];

        if (index > 0 && exceptions.includes(word.toLowerCase())) {
          return word.toLowerCase();
        }

        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  };
  return (
    <>
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="home">
        <div
          className="container pt-5 in-mobile desktop_content"
          style={{ paddingBottom: "40px" }}
        >
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>
        <div className="sidebar">
          <div className="container">
            <div className="row">
              <div className="col-lg-4  col-md-4 desktop_content">
                <Aside activeTab={activeTab} setActiveTab={setActiveTab} />
              </div>
              <div className="col-lg-8 col-md-8 in-mobile">
                <div className="tabs">
                  <div className="tab_content">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div
                        className=""
                        id="v-pills-offersHistory"
                        role="tabpanel"
                        aria-labelledby="v-pills-offersHistory-tab"
                        tabIndex="0"
                      >
                        <div className="offersHistory recent">
                          <div className="search search1">
                            <div className="d-flex justify-content-between align-items-center filter-box">
                              <h1 className="desktop_content">
                                Rewards Catalogue
                              </h1>
                              <div className="container mobile_content">
                                <Breadcrumbs
                                  separator={
                                    <NavigateNextIcon
                                      fontSize="small"
                                      sx={{ color: "#A9A9A9" }}
                                    />
                                  }
                                  aria-label="breadcrumb"
                                >
                                  {breadcrumbsMobile}
                                </Breadcrumbs>
                              </div>

                              {/* <div
                                className="mobile_content"
                                onClick={() => navigate("/home")}
                              >
                                <img
                                  src={BackIcon}
                                  alt="back icon"
                                  width={10}
                                  height={24}
                                />
                                <h1>Rewards</h1>
                              </div> */}
                              {currenttabIndex === 0 && (
                                <div className="flex">
                                  <div>
                                    <FormControl
                                      sx={{
                                        // m: 1,
                                        marginRight: "10px",
                                        width: 220,
                                        border: "1px solid black",
                                      }}
                                      size="small"
                                    >
                                      <Select
                                        value={mall}
                                        onChange={(e) => {
                                          // console.log(e, "val");
                                          setMall(e.target.value);
                                        }}
                                        displayEmpty
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                        labelId="demo-select-small-label"
                                        id="demo-select-small"
                                        sx={{
                                          backgroundColor: {
                                            xs: "#fff",
                                          },
                                        }}
                                      >
                                        <MenuItem value="">
                                          <p>Search by Mall</p>
                                        </MenuItem>

                                        <MenuItem value="All">
                                          <p>All</p>
                                        </MenuItem>
                                        <MenuItem
                                          value="special benefits"
                                          sx={{ color: "#4caf50" }}
                                        >
                                          <p>Special Benefits</p>
                                        </MenuItem>
                                        {categoryListData?.map((el) => (
                                          <MenuItem
                                            key={el?.id}
                                            value={el?.name}
                                          >
                                            {/* {el?.name} */}
                                            <p
                                            // style={{
                                            //   textTransform: "capitalize",
                                            // }}
                                            >
                                              {capitalizeCategory(el?.name)}
                                            </p>
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </div>
                                  <div className="btn-cont">
                                    <button
                                      className="radius0_button"
                                      onClick={() => {
                                        handleSubmit(mall, currenttabIndex);
                                      }}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                            <h1
                              className="mobile_content"
                              style={{ color: "#ffffff", marginTop: "10px" }}
                            >
                              Rewards Catalogue
                            </h1>
                          </div>

                          <div className="tabs">
                            {/* <Box sx={{ maxWidth: "80vw" }}> */}
                            <Box
                              sx={{
                                maxWidth: {
                                  xs: "100vw", // for extra-small screens (phones)
                                  sm: "80vw", // for small screens and up (tablets, etc.)
                                },
                              }}
                            >
                              <Tabs
                                value={currenttabIndex}
                                onChange={handleChange}
                                scrollButtons="auto"
                                aria-label="scrollable auto tabs example"
                                allowScrollButtonsMobile
                                sx={{
                                  background: {
                                    xs: "black",
                                    sm: "unset",
                                  },
                                }}
                              >
                                <Tab
                                  sx={{
                                    maxWidth: "33.33%",
                                    width: "33.33%",
                                    borderRadius: 2,
                                  }}
                                  label="My Rewards"
                                />
                                <Tab
                                  sx={{ maxWidth: "33.33%", width: "33.33%" }}
                                  label="Activated Rewards"
                                />
                                <Tab
                                  sx={{ maxWidth: "33.33%", width: "33.33%" }}
                                  label="Expired Rewards"
                                />
                              </Tabs>
                            </Box>
                            <div className="tab_content in-mobile-pad">
                              <Box>
                                {currenttabIndex === 0 && (
                                  <div
                                    className="tabTable"
                                    style={{
                                      maxHeight: "100vh",
                                      overflowY: "scroll",
                                    }}
                                  >
                                    <div className="border_bottom_section">
                                      {rewards?.length > 0 ? (
                                        rewards?.map((offer) => {
                                          const isBlocked = isRewardBlocked(
                                            offer,
                                            redemptionAllowance,
                                          );
                                          return (
                                          <div
                                            key={offer?.id}
                                            className={`mobile-div${
                                              isBlocked
                                                ? " reward-row-blocked"
                                                : ""
                                            }`}
                                            style={{
                                              cursor: isBlocked
                                                ? "not-allowed"
                                                : "pointer",
                                            }}
                                            aria-disabled={isBlocked}
                                            onClick={() => {
                                              if (isBlocked) return;
                                              navigate("/reward-page", {
                                                state: offer,
                                              });
                                            }}
                                          >
                                            {/* <p className="mobile_content">
                                              {moment(offer?.startTime).format(
                                                "DD MMM YYYY"
                                              )}
                                            </p> */}
                                            <div className="d-flex justify-content-between transction_list ptop-0">
                                              <div className="hotel_booking_details d-flex align-items-center">
                                                <img
                                                  className="hotel_Icon_div"
                                                  src={offer?.thumbnailUrl}
                                                  alt="Store logo"
                                                />
                                                <div className="details-container">
                                                  {/* <p className="desktop_content">
                                                    {moment(
                                                      offer?.startTime
                                                    ).format("DD MMM YYYY")}
                                                  </p> */}
                                                  <h1>{offer?.name}</h1>
                                                  {isBlocked && (
                                                    <>
                                                      <span className="limit-badge">
                                                        {
                                                          REDEMPTION_ALLOWANCE_COPY.blockedBadge
                                                        }
                                                      </span>
                                                      <p className="limit-reason">
                                                        {getBlockedReason(
                                                          redemptionAllowance,
                                                        )}
                                                      </p>
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                              <div className="points_gold">
                                                {offer?.intouchPoints === 0 && (
                                                  <span className="free-tag">
                                                    Special Benefits
                                                  </span>
                                                )}
                                                <p className="high_light_text">
                                                  {formatRewardCatalogueAmount(
                                                    offer?.intouchPoints,
                                                  )}
                                                  <img
                                                    src={gold_rupe_icon_md}
                                                    alt="gold coin icon"
                                                  />
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          );
                                        })
                                      ) : loading ? null : (
                                        <NoDataComp />
                                      )}
                                    </div>
                                    {loading || !currentSlab ? (
                                      <div className="spinner_table_height">
                                        <Spinner color="black" size="28px" />
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                                {currenttabIndex === 1 && (
                                  <ActiveOffers mall={mall} />
                                )}
                                {currenttabIndex === 2 && <ExpiredRewards />}
                              </Box>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerMobPending"></div>
      <Footer2 selected="rewards" />
    </>
  );
};

export default OffersHistory;
